<template lang="pug">
el-container.main
  .main-search
    el-form(
      :model="searchForm",
      ref="searchForm",
      label-width="100px",
      label-position="left",
      :inline="true"
    )
      el-form-item(prop="name")
        el-input.search-input(v-model="searchForm.name", placeholder="载荷名称")
      el-form-item
        el-button.search-btn(
          type="primary",
          icon="el-icon-search",
          @click="submitForm('searchForm')"
        ) 搜索
        template(v-if="advancedFilter")
          el-button(
            type="text",
            icon="el-icon-arrow-up",
            @click="switchAdvancedFilter"
          ) 高级检索
        template(v-else)
          el-button(
            type="text",
            icon="el-icon-arrow-down",
            @click="switchAdvancedFilter"
          ) 高级检索
  .main-filter(v-show="this.advancedFilter")
    .filter-item
      el-form(
        :model="searchForm",
        ref="searchForm",
        label-width="100px",
        label-position="left",
        :inline="formInLine"
      )
        el-form-item(label="仪器类型")
          el-cascader(
            v-model="searchForm.classification",
            :options="insClassificationOptions",
            placeholder="请选择仪器类型",
            clearable
          )
        el-form-item(
          v-if="searchForm.classification.includes('1')",
          label="光谱波段(um)",
          prop="spectral_range"
        )
          el-row
            el-col(:span="8")
              el-input(
                placeholder="最小值",
                type="number",
                v-model="searchForm.spectralrange.min"
              )
            el-col.mid-dash(:span="2") -
            el-col(:span="8")
              el-input(
                placeholder="最大值",
                type="number",
                v-model="searchForm.spectralrange.max"
              )
        el-form-item(
          v-if="this.searchForm.classification.includes('2')",
          label="雷达波段"
        )
          el-select(
            v-model="searchForm.sarBand",
            placeholder="请选择雷达波段",
            multiple,
            collapse-tags
          )
            el-option(
              v-for="item in this.sarBandOptions",
              :key="item.value",
              :label="item.label",
              :value="item.value"
            )
        el-form-item(
          v-if="this.searchForm.classification.includes('2')",
          label="扫描模式"
        )
          el-select(
            v-model="searchForm.sarMode",
            placeholder="请选择扫描模式",
            multiple,
            collapse-tags
          )
            el-option(
              v-for="item in this.sarModeOptions",
              :key="item.value",
              :label="item.label",
              :value="item.value"
            )
  .main-content
    el-table.pc(
      :data="items",
      :stripe="true",
      border,
      style="width: 100%",
      :header-cell-style="tableHeaderColor"
    )
      el-table-column(prop="name", label="仪器", width="180")
        template(slot-scope="scope")
          router-link(
            :to="{ name: 'instrument-detail', params: { id: scope.row.id.toString() } }"
          ) {{ scope.row.name }}
          el-tooltip(v-if="scope.row.verified" lass="item" effect="light" content="数据已校正" placement="right")
            i.el-icon-success(style="color: green;")
      el-table-column(prop="classification", label="类型")
        template(slot-scope="scope") {{ scope.row.classification.name }}
      el-table-column(prop="utilization_period", label="使用年限")
      el-table-column(prop="agency", label="研发机构")
    el-table.phone(
      :data="items",
      :stripe="true",
      border,
      style="width: 100%",
      :header-cell-style="tableHeaderColor"
    )
      el-table-column(prop="name", label="仪器", width="160")
        template(slot-scope="scope")
          router-link(
            :to="{ name: 'instrument-detail', params: { id: scope.row.id.toString() } }"
          ) {{ scope.row.name }}
      el-table-column(prop="agency", label="研发机构")
  .main-pager
    el-pagination.page(
      @size-change="handleSizeChange",
      layout="total, sizes, prev, next, jumper",
      :page-sizes="[10, 20, 50]",
      :current-page.sync="pagination.currentPage",
      :page-size.sync="pagination.pageSize"
      :total="pagination.total"
    )
</template>

<script>
// @ is an alias to /src
import { listInstrument, listInstrumentType } from "@/services";
const defaultSearchForm = {
  name: "",
  insType: [],
  classification: [],
  spectralrange: {
    min: null,
    max: null,
  },
  sarBand: [],
  sarMode: [],
};

export default {
  name: "instrument",
  data() {
    return {
      loading: false,
      selected: [],
      items: [],
      pagination: {
        total: 1,
        currentPage: 1,
        pageSize: 10,
      },
      advancedFilter: false,
      formInLine: true,
      searchForm: Object.assign({}, defaultSearchForm),
      insTypeCheckIndeterminate: false,
      checkAllInsType: true,
      insClassificationOptions: [
        {
          value: "1",
          label: "光学",
        },
        {
          value: "2",
          label: "SAR",
        },
      ],
      sarBandOptions: [
        { value: "C", label: "C-Band" },
        { value: "L", label: "L-Band" },
        { value: "S", label: "S-Band" },
        { value: "X", label: "X-Band" },
      ],
      sarModeOptions: [
        { value: "ScanSAR", label: "ScanSAR" },
        { value: "Stripmap", label: "Stripmap" },
        { value: "Spotlight", label: "Spotlight" },
      ],
    };
  },
  watch: {
    searchForm: {
      handler() {
        this.pagination.currentPage = 1;
        this.pagination.pageSize = 10;
      },
      deep: true,
      immediate: true,
    },
    "pagination.currentPage": {
      handler() {
        this.fetch();
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * Backend Service API Func Wrapper
     */
    async fetch() {
      this.selected = [];
      this.loading = true;
      const res = await listInstrument(
        this._.pickBy(
          {
            size: this.pagination.pageSize,
            page: this.pagination.currentPage,
            name: this.searchForm.name,
            band: this.searchForm.sarBand,
            mode: this.searchForm.sarMode,
            spectral_range:
              this.searchForm.spectralrange.min ||
                this.searchForm.spectralrange.max
                ? [
                  this.searchForm.spectralrange.min,
                  this.searchForm.spectralrange.max,
                ].join(",")
                : "",
          },
          this._.identity
        )
      );
      this.items = res.data.items;
      this.pagination.total = res.data.total;
      this.loading = false;
    },
    /**
     * UI Control
     */
    setFormInLine() {
      if (screen.width > 540) {
        this.formInLine = true;
      } else {
        this.formInLine = false;
      }
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.fetch();
    },
    submitForm() {
      this.fetch();
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;color: #8493A8;";
      }
    },
    switchAdvancedFilter() {
      this.advancedFilter = !this.advancedFilter;
    },
  },
  mounted() {
    this.setFormInLine();
    this.fetch();
  },
};
</script>
<style lang="stylus" scoped>
.basic-search {
  padding-right: 60px;
}

.search-input {
  width: 360px;
}

.search-btn {
  width: 140px;
}

.mid-dash {
  text-align: center;
}

.adfilter-select {
  width: 270px;
}

.phone {
  display: none;
}

@media only screen and (max-width: 540px) {
  .search-input {
    width: 280px;
  }

  .pc {
    display: none;
  }

  .phone {
    display: inline;
  }
}
</style>
